import React from 'react';
import type { AdminDashboardCompany } from '../../../models/adminDashboard';

function getStatusBars(companies: AdminDashboardCompany[]): Array<{ label: string; value: number }> {
  const totals = companies.reduce<Record<string, number>>((acc, company) => {
    Object.entries(company.orderCountsByStatus).forEach(([status, count]) => {
      acc[status] = (acc[status] ?? 0) + count;
    });
    return acc;
  }, {});

  return Object.entries(totals)
    .sort((a, b) => b[1] - a[1])
    .map(([label, value]) => ({ label, value }));
}

export function StatusCharts({ companies }: { companies: AdminDashboardCompany[] }): React.ReactElement {
  const bars = getStatusBars(companies);

  return (
    <div className="bo-card bo-admin-chart-card">
      <h2 className="bo-admin-section-title">Order status distribution</h2>
      {bars.length === 0 ? (
        <p className="bo-muted">No order status data available.</p>
      ) : (
        <div className="bo-admin-chart-list" role="list">
          {bars.map((bar) => (
            <div key={bar.label} className="bo-admin-chart-row" role="listitem">
              <div className="bo-admin-chart-label-row">
                <span>{bar.label}</span>
                <strong>{bar.value}</strong>
              </div>
              <div className="bo-admin-chart-track" aria-hidden>
                <div className="bo-admin-chart-fill" style={{ width: `${Math.min(100, bar.value * 4)}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
